import React from "react";
import DatosDemograficos from '../../../containers/DatosDemograficos'
import { CAMPAIGN_2024 } from '../../../constants';

const EvacuadosPorProvincia = () => {
  return <DatosDemograficos campaign={CAMPAIGN_2024} year={2024}/>
};

export default EvacuadosPorProvincia;
